import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import "../components/componentstyle/stateSection.css"; 
import { FaBriefcase, FaFlag, FaTrophy, FaUser } from "react-icons/fa";

const statsData = [
  { id: 1, icon: <FaBriefcase />, number: 30, label: "Years of Experience" },
  { id: 2, icon: <FaFlag />, number: 50, label: "Countries" },
  { id: 3, icon: <FaUser />, number: 25, label: "Commodities" },
  { id: 4, icon: <FaTrophy />, number: 10, label: "Awards" },
];

const StatsSection = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <div className="stats-section" ref={ref}>
      {statsData.map((item) => (
        <div className="stat-card" key={item.id}>
          <div className="icon">{item.icon}</div>
          <div className="number">
            {inView ? <CountUp end={item.number} duration={10} /> : 0}
          </div>
          <div className="label">{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;
